import { BasePage } from "@Tenants/Fun/Site/BasePage";
import { ModalTools } from "@Utilities/ModalTools";
import { UnobtrusiveValidation } from "@Validation/UnobtrusiveValidation";
import IMask from "imask/holder";
import "imask/masked/pattern";

export class BasePrivacy
{
	public Form: HTMLFormElement | null = document.getElementById("privacyForm") as HTMLFormElement | null;
	public Validation: UnobtrusiveValidation;

	constructor()
	{
		this.Initialize();
	}

	public Initialize(): void
	{
		this.ConfigureForm();
	}

	public ConfigureForm = (): void =>
	{
		this.Validation = new UnobtrusiveValidation();

		this.Validation.Ajax.AjaxOnFailure = (xhr: XMLHttpRequest) =>
		{
			ModalTools.DisplayAlert("An error occurred while processing your request. Please try again.");
		};

		this.ConfigureInputMasks();
	};

	private ConfigureInputMasks = () =>
	{
		const emailInput = document.getElementById("EmailAddress") as HTMLInputElement;

		if (emailInput !== null)
		{
			IMask(
				emailInput,
				{
					mask: /^\S*@?\S*$/
				}
			);
		}
	};
}